import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import {
    FootNote,
    SizeCell,
    SplitCaKingCell,
    SplitKingCell,
    sizeIcons,
} from "./_shared";

import styles from "../../../styles/composable/product-specifications.module.scss";

/**
 * Native port of ``cms/blocks/product-specifications/luxebreeze.html`` (#33410).
 * ``breeze-specifications`` wrapper; six size cells with LuxeBreeze weights.
 */
export const LuxeBreeze = (): React.JSX.Element => (
    <div
        className={concatClassNames([
            "breeze-specifications",
            styles.specifications,
        ])}
    >
        <SizeCell
            icon={sizeIcons.adaptTwinXl}
            heading="Twin Long"
            lines={['38" x 80"', "Single Mattress", "78-100 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptQueen}
            heading="Queen"
            lines={['60" x 80"', "Single Mattress", "123-168 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptKing}
            heading="King"
            lines={['76" x 80"', "Single Mattress", "157-216 lbs"]}
        />
        <SplitKingCell
            lines={['76" x 80"', "Double Mattress", "156-210 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptCaKing}
            heading="CA King"
            lines={['72" x 84"', "Single Mattress", "157-216 lbs"]}
        />
        <SplitCaKingCell
            lines={['72" x 84"', "Double Mattress", "156-210 lbs"]}
        />

        <FootNote />
    </div>
);
